module.exports = __webpack_public_path__ + "img/icon-down-chevron-red.370cfb8b.svg";